import * as React from 'react'
import { Props, State, CLASSNAME } from './types'
import './styles.scss'
// @ts-ignore
import ICON_CARET from '../../assets/caret.svg'
// @ts-ignore
import ICON_VALIDATE from '../../assets/icon-validate.svg'
import { ISelect } from '../SelectV2/types'

export class HorizontalList extends React.Component<Props, State> {
  refElement: any

  constructor(props: Props) {
    super(props)

    this.state = {
      numberSelectedItems: 0,
      elements: [],
      isOpenDropdown: false,
      isCaretOpen: false,
      defaultPattern: [],
    }

    this.refElement = React.createRef()

    this.onHandleActive = this.onHandleActive.bind(this)
    this.onHandleOpen = this.onHandleOpen.bind(this)
    this.onClickDropdownElement = this.onClickDropdownElement.bind(this)
    this.renderCustom = this.renderCustom.bind(this)
    this.selectElementList = this.selectElementList.bind(this)
  }

  componentDidMount() {
    this.setState({ defaultPattern: [...this.props.defaultPattern, { value: 'custom', label: 'Personnaliser' }] })
  }

  componentDidUpdate(nextProps: Props, nextState: State) {
    const { elements } = this.state
    const { elements: nextElements } = nextState

    if (elements?.length !== nextElements.length) {
      this.props.selectedElements(elements)
    }

    if (elements?.length === nextElements.length) {
      const domElements = document.querySelectorAll(CLASSNAME.TITLE)

      for (let i = 0; i < domElements.length; i += 1) {
        let getAttribute: any = domElements[i].getAttribute('data-value')
        const regexNumber = /^[0-9]*$/

        if (regexNumber.test(getAttribute)) {
          getAttribute = Number(getAttribute)
        }

        if (this.state.elements.some(el => el?.value === getAttribute)) {
          domElements[i].classList.add('horizontalList__active')
        }
      }
    }

    if (this.state.isOpenDropdown !== nextState.isOpenDropdown) {
      if (this.props.onHandleCustomFilters) {
        this.props.onHandleCustomFilters(this.state.isOpenDropdown)
      }
    }
  }

  selectElementList(el: ISelect, event: any) {
    const elements = document.querySelectorAll('.horizontalList__title')

    event.target.classList.toggle('horizontalList__active')

    if (elements[elements.length - 1].classList.contains('horizontalList__active')) {
      if (el.value !== 'custom') {
        elements[elements.length - 1].classList.remove('horizontalList__active')

        this.setState({ isOpenDropdown: false })
      }
    }

    if (el.value === 'custom') {
      for (let i = 0; i < elements.length; i += 1) {
        elements[i].classList.remove('horizontalList__active')

        event.target.classList.toggle('horizontalList__active')
      }

      this.setState({ isOpenDropdown: true })
    }
  }

  onHandleActive(el: ISelect, index: number, event: any) {
    this.selectElementList(el, event)

    const getActiveElements = document.querySelectorAll('.horizontalList__active')

    let finalElements: any = []

    for (let i = 0; i < getActiveElements.length; i += 1) {
      const attr = getActiveElements[i].getAttribute('data-value')

      const elements = this.props.list.find(el => el.value === attr?.trim())

      if (elements) {
        finalElements = [...finalElements, elements]
      }
    }

    this.setState({
      elements: finalElements
    })

    this.props.selectedElements(finalElements)
  }

  onHandleOpen(isCaret?: boolean) {
    if (typeof isCaret !== 'undefined') {
      this.setState({ isOpenDropdown: isCaret })
    } else {
      this.setState({ isOpenDropdown: !this.state.isOpenDropdown })
    }
  }

  onClickDropdownElement(el: ISelect, index: number) {
    let element: any = null

    if (typeof el.value === 'number') {
      element = document.querySelectorAll('.horizontalList__item')[el.value as any]
    }

    element = document.querySelectorAll('.horizontalList__item')[index as any]

    element.classList.toggle('horizontalList__active')

    if (element.classList.contains('horizontalList__active')) {
      this.setState({
        elements: [...this.state.elements, el]
      })
      this.props.selectedElements([...this.state.elements, el])
    } else {
      this.setState({
        elements: this.state.elements.filter(elmt => elmt?.value !== el?.value)
      })

      this.props.selectedElements(this.state.elements.filter(elmt => elmt?.value !== el?.value))
    }
  }

  renderCustom() {
    const { data } = this.props

    if (data && Array.isArray(data) && data.length > 0) {
      return (
        <div
          className="horizontalList__custom"
          ref={this.refElement}
        >
          <div
            style={{ cursor: 'pointer' }}
          >
            <ICON_CARET
              width="12"
              height="12"
              onClick={() => {
                this.setState({ isCaretOpen: !this.state.isCaretOpen })
                // this.onHandleOpen(this.state.isCaretOpen)
              }}
            />
          </div>

          {this.state.isCaretOpen && (
            <div
              className="horizontalList__dropdown"
            >
              <div
                className="horizontalList__items"
              >
                {data?.map((el, index) => (
                  <div
                    key={`${el.value}__${index}`}
                    className="horizontalList__item horizontalList__title"
                    style={{ marginLeft: '0' }}
                    onClick={() => this.onClickDropdownElement(el, index)}
                    data-value={el.value}
                  >
                    <div className="horizontalList__checkbox">
                      <ICON_VALIDATE />
                    </div>
                    <p>{el.label}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )
    }

    return null
  }

  render() {
    const elements = [
      ...this.props.defaultPattern,
      {
        value: 'custom',
        label: 'Personnaliser'
      }
    ]

    return (
      <div
        className="horizontalList"
      >
        { elements?.map((el: ISelect, index: number) => (
          <p
            key={el.value}
            className="horizontalList__title"
            data-value={el.value}
            onClick={(event: any) => {
              this.onHandleActive(el, index, event)
              if (el.value === 'custom') {
                this.setState({ isOpenDropdown: !this.state.isOpenDropdown })
                this.onHandleOpen()
              }
            }}
          >
            {el.label}
          </p>
        ))}
        { this.renderCustom()}
      </div>
    )
  }
}
